import React from 'react';
import { Autocomplete as AutocompleteMUI, MenuItem } from '@mui/material';
import { __ } from '../../../../shared/tools';
import clsx from 'clsx';

import style from './style.module.scss';

const Autocomplete = ({ id, name, label, required, placeholder, options, errors, ...props }) => {
    const err = errors.filter((el) => el.field === name);

    return (
        <div className={style.block}>
            <label className={clsx(style.label, required && style.required)} htmlFor={id}>
                {label}
            </label>

            <AutocompleteMUI
                className={style.autocomplete}
                classes={{
                    paper: style.paper,
                    noOptions: style.noOptions,
                }}
                options={options || []}
                autoHighlight
                disableClearable
                noOptionsText={__('Aucune option')}
                renderOption={(props, option) => (
                    <MenuItem {...props} className={style.item}>
                        {option}
                    </MenuItem>
                )}
                renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                        <input
                            name={name}
                            required={required}
                            placeholder={placeholder}
                            type="text"
                            {...params.inputProps}
                            className={style.input}
                        />
                    </div>
                )}
                {...props}
            />

            {err && err.length ? <div className={style.error}>{err[0].message}</div> : <></>}
        </div>
    );
};

export default Autocomplete;
